var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-circular-loading-bar",class:[_vm.color]},[_c('div',{staticClass:"base-circular-loading-bar__content"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"indeterminate":""}}),(_vm.text)?_c('div',{staticClass:"base-circular-loading-bar__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }